import firebase from 'firebase/app'
import 'firebase/firestore'

// Get a Firestore instance
export const db = firebase
    .initializeApp(
        {
            apiKey: "AIzaSyBGYghm-D2EYZyRCIPlvCduVtxYNMAehEQ",
            authDomain: "ilsa-661a4.firebaseapp.com",
            databaseURL: "https://ilsa-661a4.firebaseio.com",
            projectId: "ilsa-661a4",
            storageBucket: "ilsa-661a4.appspot.com",
            messagingSenderId: "394230192742",
            appId: "1:394230192742:web:6729b93865aae0d66e6ba7"
        })
    .firestore()

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples

// const { Timestamp, GeoPoint } = firebase.firestore
// export { Timestamp, GeoPoint }

// if using Firebase JS SDK < 5.8.0
// db.settings({ timestampsInSnapshots: true })